import PropTypes from 'prop-types';
import React from 'react';
import ModalContent from './Content/ModalContent';
import ModalFooter from './Footer/ModalFooter';
import ModalHeader from './Header/ModalHeader';

import './ModalGeneral.scss';
import '../investor/KycModal/loader.scss';

class ModalGeneral extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      open: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    // Made to fade out after open, and fade in before closing
    if (this.props.show !== nextProps.show) {
      if (!nextProps.show) {
        this.setState({ visible: false });
        setTimeout(() => {
          this.setState({ open: nextProps.show });
        }, 500);
      } else {
        this.setState({ open: true });
        setTimeout(() => {
          this.setState({ visible: nextProps.show });
        }, 100);
      }
    }
    if (nextProps.show && !this.state.visible && !this.state.open) {
      this.setState({ open: true });
      setTimeout(() => {
        this.setState({ visible: nextProps.show });
      }, 100);
    }
  }

  render() {
    const {
      header,
      underlineColor,
      backdropColor,
      content,
      onPrimaryClick,
      show,
      onSecondaryClick,
      secondaryLabel,
      primaryLabel,
      isSecondaryAlignLeft,
      externalClass = 'defaultWidth',
      isDisabledPrimary,
      buttonObject = null,
    } = this.props;
    if (!this.state.open) {
      return null;
    }
    const backgroundColor = backdropColor || underlineColor || 'black';

    // for fade-in fade-out transition
    const modalMode = this.state.visible ? 'open' : '';
    return (
      <div className={'modal-main'}>
        <div className={`modal-backdrop ${backgroundColor}`}>
          <div className='modal-main--wrapper'>
            <div
              className={`modal-main--container ${modalMode} ${externalClass}`}
            >
              <ModalHeader header={header} underlineColor={underlineColor} />
              {content ? (
                <ModalContent content={content} />
              ) : (
                <ModalContent>{this.props.children}</ModalContent>
              )}
              {!this.props.showLoader && (
                <ModalFooter
                  onPrimaryClick={onPrimaryClick}
                  onSecondaryClick={onSecondaryClick}
                  secondaryLabel={secondaryLabel}
                  primaryLabel={primaryLabel}
                  isSecondaryAlignLeft={isSecondaryAlignLeft}
                  isDisabledPrimary={isDisabledPrimary}
                  buttonObject={buttonObject}
                  show={show}
                />
              )}
              {this.props.showLoader && (
                <div className='loader-wrapper'>
                  <div className='loader'></div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ModalGeneral.propTypes = {
  children: PropTypes.node,
  show: PropTypes.bool,
  isSecondaryAlignLeft: PropTypes.bool,
  header: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  content: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  backdropColor: PropTypes.oneOf(['blue', 'green', 'black']),
  underlineColor: PropTypes.oneOf(['blue', 'green', 'black', 'red']),
  onPrimaryClick: PropTypes.func,
  onSecondaryClick: PropTypes.func,
  secondaryLabel: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  primaryLabel: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  externalClass: PropTypes.string,
  isDisabledPrimary: PropTypes.bool,
  showLoader: PropTypes.bool,
};

export default ModalGeneral;
